import * as STUDENTACTIONS from '../../actions/student.action'

const initialState = {
    loading: false,
    success: false,
    failure: false,
    status:'',
    status_code:'',
    message:'',
    data:[]
}

export default function returnstate(state = initialState, action) {

    switch (action.type) {
        case STUDENTACTIONS.UPDATE_COURSE.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                failure: false,
            };
        case STUDENTACTIONS.UPDATE_COURSE.SUCCESS:     
        return {
                ...state,
                loading: false,
                success: true,
                failure: false,
                status:action.payload.status,
                status_code:action.payload.status_code,
                message:action.payload.message,
                data:action.payload.data
            };

        case STUDENTACTIONS.UPDATE_COURSE.FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                failure: true,
                status:action.payload.status,
                status_code:action.payload.status_code,
                message:action.payload.message,
                data:action.payload.data
            };
            case STUDENTACTIONS.RESET_UPDATE_COURSE.SUCCESS:
                return {
                    ...state,
                    loading: false,
                    success: false,
                    failure: false,
                    status:'',
                    status_code:'',
                    message:'',
                    data:[]
                };
        default: return state
    }
}